// Google Analytics helpers. The gtag stub in public/index.html is defined before the
// gtag library loads, so events sent early queue in dataLayer and are sent once the
// library arrives.

// Sends a GA4 event. No-op when the analytics snippet is absent.
export function trackEvent(name, params = {}) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', name, { ...params, page_path: window.location.pathname });
}

// Contact links are plain anchors spread over nine files, so one delegated listener
// covers them all and keeps new links tracked without extra wiring.
const CONTACT_EVENTS = [
  { test: (href) => href.includes('wa.me'), event: 'whatsapp_click' },
  { test: (href) => href.startsWith('mailto:'), event: 'email_click' },
  { test: (href) => href.startsWith('tel:'), event: 'phone_click' },
];

export function trackContactClicks() {
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element && event.target.closest('a[href]');
    if (!link) return;

    const href = link.getAttribute('href');
    const match = CONTACT_EVENTS.find(({ test }) => test(href));
    if (!match) return;

    trackEvent(match.event, {
      link_url: href,
      // The label identifies which CTA was clicked, e.g. 'Order Now' or 'Chat with Us'.
      link_text: (link.textContent || '').trim().slice(0, 100),
    });
  });
}
